import React, { useEffect, useState } from "react";
import img from "../assets/image 57.svg";

export default function Card2(props) {
  return (
    <div
      className={
        "w-4/5 md:w-[100%] h-1/5 md:h-[100%] bg-white border-2 border-[#00000040] rounded-[15px] shadow-xl p-4 md:p-3  flex flex-col justify-center md:mt-3 md:mb-3  items-center mt-4 mb-4 self-center "
      }
    >
      <img
        className="object-center w-30 h-20 rounded-lg"
        src={props.category["image"]}
        alt=""
      />
      <div className="text-black md:flex md:flex-wrap font-montserrat text-base font-semibold md:text-[20px] text-center mt-2 md:mx-auto">
        {props.category["title"]}
      </div>
      <div className="text-black font-montserrat text-xs font-normal md:text-[13px] md:px-5 text-center mt-2 " dangerouslySetInnerHTML={{ __html: props.category["description"] }}>
      </div>
    </div>
  );
}
